export default __webpack_public_path__ + "static/brand-presentation-ui-4c97866606c9b68dcbba93bc22a41da4.png";